module.exports = __webpack_public_path__ + "img/success.e262cbb5.png";